import Header from './components/header/Header';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import EventSearch from './components/event/EventSearch';
import EventDetails from './components/event/EventDetails';
import MyAccount from './components/myAccount/MyAccount';
import FormsAndReports from './components/formsAndReports/FormsAndReport';
import Logout from './components/logout/Logout';
import NotFound from './components/notFound/NotFound';
import Login from './components/login/Login';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import RequestInterceptor from './components/commons/RequestInterceptor';
import { useEffect } from 'react';
import { useAppDispatch } from './app/hooks';
import { setUser } from './app/slices/userSlice';
import Footer from './components/footer/Footer';
import { Box } from '@mui/material';
import UserRole from './model/user-role';
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import PhotoDayImport from './components/photoDay/PhotoDayImport';

function App() {
  const isAuthenticated = useIsAuthenticated();
  const dispatch = useAppDispatch();
  const { instance, inProgress, accounts } = useMsal();

  useEffect(() => {
    if (isAuthenticated && accounts.length > 0) {
      dispatch(
        setUser({
          id: accounts[0].username,
          name: accounts[0].name,
          roles: accounts[0].idTokenClaims?.roles as UserRole[],
        })
      );
    }
  }, [isAuthenticated, accounts, dispatch]);

  useEffect(() => {
    const accessTokenRequest = {
      scopes: ['user.read'],
      account: accounts[0],
    };
    if (isAuthenticated && accounts.length > 0 && inProgress === InteractionStatus.None) {
      instance
        .acquireTokenSilent(accessTokenRequest)
        .then(function (accessTokenResponse) {
          console.log('Acquire token silent success');
        })
        .catch((error) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          console.log(error);
        });
    }
  }, [instance, inProgress, accounts, isAuthenticated]);

  return (
    <div className="App">
      <Box className="AppBody">
        <AuthenticatedTemplate>
          <RequestInterceptor>
            <>
          <Header />
            <Routes>
              <Route path='/photoDay' element={<PhotoDayImport />} />
              <Route path="/" element={<EventSearch />} />
              <Route path="event-details/:eventId" element={<EventDetails />} />
              <Route path="my-account" element={<MyAccount />} />
              <Route path="forms-reports" element={<FormsAndReports />} />
              <Route path="logout" element={<Logout />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            </>
          </RequestInterceptor>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Login />
        </UnauthenticatedTemplate>
      </Box>
      <Footer />
    </div>
  );
}

export default App;
